// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root\" focusable=\"false\" aria-hidden=\"true\" viewBox=\"0 0 24 24\" data-testid=\"VisibilityIcon\"><path d=\"M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z\"></path></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root\" focusable=\"false\" aria-hidden=\"true\" viewBox=\"0 0 24 24\" data-testid=\"EditIcon\"><path d=\"M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z\"></path></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root\" focusable=\"false\" aria-hidden=\"true\" viewBox=\"0 0 24 24\" data-testid=\"BuildIcon\"><path d=\"m22.7 19-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z\"></path></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root\" focusable=\"false\" aria-hidden=\"true\" viewBox=\"0 0 24 24\" data-testid=\"AddIcon\"><path d=\"M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z\"></path></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root\" focusable=\"false\" aria-hidden=\"true\" viewBox=\"0 0 24 24\" data-testid=\"RemoveIcon\"><path d=\"M19 13H5v-2h14v2z\"></path></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\" viewBox=\"0 0 24 24\" data-testid=\"CheckBoxIcon\"><path d=\"M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z\"></path></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\" viewBox=\"0 0 24 24\" data-testid=\"CheckBoxOutlineBlankIcon\"><path d=\"M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z\"></path></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-kermit-document] {
  /*
    .kp[data-kt="markdown"] {
      width: 100%;

      .kpv {
        width: 100%;
      }

      .kpv-raw {
        text-align: center;
        width: 100%;
      }
    }
  */
}
[data-kermit-document] .kd-source, [data-kermit-document] .kp-source {
  display: none;
}
[data-kermit-document] fieldset {
  border: none;
  margin: 0;
  padding: 0;
}
[data-kermit-document] legend {
  opacity: 0;
  font-size: 0;
}
[data-kermit-document] .kt-options select {
  display: block;
  user-select: none;
  cursor: pointer;
  box-sizing: content-box;
  background: none;
  width: 100%;
  min-height: 24px;
  font-size: 1em;
  font-weight: 400;
  letter-spacing: 0.033px;
  font-family: "Poppins";
  padding: 0;
  border: 0;
  border-radius: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}
[data-kermit-document] .kpv-input input:focus, [data-kermit-document] .kpv-input textarea:focus {
  outline-style: none;
  /*
  background-color: #00000022;
  */
}
[data-kermit-document] .kpv-input textarea {
  max-height: 9.5em;
}
[data-kermit-document] .kd {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 25px;
}
[data-kermit-document] .kp.kp-cond-hidden {
  display: none;
}
[data-kermit-document] .kd-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
[data-kermit-document] .kd-name {
  color: #315AB7;
  font-family: Haboro Soft, sans-serif;
  font-size: 1.5em;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
  letter-spacing: 0.033px;
}
[data-kermit-document] .kd-submit {
  display: none;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
[data-kermit-document] .kd-submit button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 300px;
  height: 48px;
  padding: 12px 16px;
  border-radius: 8px;
  border: none;
  background: var(--primary-cerulean-blue-100, #2991ED);
  color: #FFFFFF;
  font-family: "Poppins";
  font-weight: 500;
}
[data-kermit-document] .kd-submit button:disabled {
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.1) 100%), var(--common-white-main, #FFF);
}
[data-kermit-document] .kd-result {
  display: none;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
[data-kermit-document] .kd[data-kd-saving=saved] {
  animation-name: saveSuccess;
  animation-duration: 3s;
  animation-iteration-count: 1;
}
[data-kermit-document] .kd[data-kd-saving=failed] {
  animation-name: saveFailed;
  animation-duration: 3s;
  animation-iteration-count: 1;
}
@keyframes saveSuccess {
  0% {
    background-color: #FFF;
  }
  50% {
    background-color: #BFB;
  }
  100% {
    background-color: #FFF;
  }
}
@keyframes saveFailed {
  0% {
    background-color: #FFF;
  }
  50% {
    background-color: #FBB;
  }
  100% {
    background-color: #FFF;
  }
}
[data-kermit-document] .kd-controls {
  display: flex;
  flex-direction: row;
  align-items: top;
}
[data-kermit-document] .kd-control {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  border-radius: 0;
  padding: 3px;
  border-radius: 0px;
  border: 1px solid #333;
  margin-right: -1px;
  background-color: #FFF;
}
[data-kermit-document] .kd-control[data-kd-selected-mode] {
  background-color: #CCC;
  border-color: #000;
  z-index: 888;
}
[data-kermit-document] .kd-control:hover {
  background-color: #EEE;
  border-color: #888;
  z-index: 999;
}
[data-kermit-document] .kd-control:first-child {
  border-radius: 5px 0 0 5px;
}
[data-kermit-document] .kd-control:last-child {
  border-radius: 0 5px 5px 0;
}
[data-kermit-document] .kd-control:only-child {
  border-radius: 5px;
}
[data-kermit-document] .kd-control .kd-control-icon {
  width: 22px;
}
[data-kermit-document] .kd-control .kd-control-label {
  font-weight: 600;
}
[data-kermit-document] .kd-control[data-kd-mode-control=view] .kd-control-icon {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
[data-kermit-document] .kd-control[data-kd-mode-control=edit] .kd-control-icon {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
[data-kermit-document] .kd-control[data-kd-mode-control=build] .kd-control-icon {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
[data-kermit-document] .kp-next {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
[data-kermit-document] .kp-next button {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  width: 300px;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid var(--primary-cerulean-blue-100, #2991ED);
  background: none;
  color: #2991ED;
  font-family: "Poppins";
  font-weight: 500;
}
[data-kermit-document] .kpv-input-box {
  width: 100%;
  min-height: 24px;
  font-size: 1em;
  font-weight: 400;
  letter-spacing: 0.033px;
  font-family: "Poppins";
  padding: 0;
  border: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  background: none;
  resize: none;
  overflow: hidden;
}
[data-kermit-document] .kpv-image-input {
  visibility: hidden;
  display: none;
  box-sizing: content-box;
}
[data-kermit-document] .kpv-file-input {
  visibility: hidden;
  display: none;
  box-sizing: content-box;
}
[data-kermit-document] .kpv-values {
  display: none;
}
[data-kermit-document] .kpv-value-image {
  width: 190px;
  height: 190px;
  object-fit: cover;
}
[data-kermit-document] .kpv-input-add-icon {
  width: 18px;
  content: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
[data-kermit-document] .kpv-value-remove-icon {
  width: 18px;
  content: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
[data-kermit-document] .kp[data-kt=image] .kpv, [data-kermit-document] .kp[data-kt=file] .kpv {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  height: auto;
  row-gap: 10px;
  column-gap: 10px;
}
[data-kermit-document] .kp[data-kt=image] .kpv .kpv-raw, [data-kermit-document] .kp[data-kt=file] .kpv .kpv-raw {
  display: none;
}
[data-kermit-document] .kp[data-kt=image] .kpv .kpv-values, [data-kermit-document] .kp[data-kt=file] .kpv .kpv-values {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow: scroll;
  width: 100%;
  height: auto;
  column-gap: 5px;
}
[data-kermit-document] .kp[data-kt=image] .kpv .kpv-values .kpv-value-remove, [data-kermit-document] .kp[data-kt=file] .kpv .kpv-values .kpv-value-remove {
  display: none;
}
[data-kermit-document] .kd[data-kd-mode=view] .kpv-raw {
  display: block;
}
[data-kermit-document] .kd[data-kd-mode=view] .kpv-values {
  display: block;
  display: none;
}
[data-kermit-document] .kd[data-kd-mode=view] .kpv-input {
  visibility: hidden;
  display: none;
}
[data-kermit-document] .kd[data-kd-mode=view] .kt {
  display: none;
}
[data-kermit-document] .kd[data-kd-mode=view] .kp[data-kt=minor_break], [data-kermit-document] .kd[data-kd-mode=view] .kp[data-kt=major_break] {
  width: 100%;
}
[data-kermit-document] .kd[data-kd-mode=view] .kp[data-kt=minor_break] .kpv, [data-kermit-document] .kd[data-kd-mode=view] .kp[data-kt=major_break] .kpv {
  width: 100%;
}
[data-kermit-document] .kd[data-kd-mode=view] .kp[data-kt=minor_break] .kpv-raw, [data-kermit-document] .kd[data-kd-mode=view] .kp[data-kt=major_break] .kpv-raw {
  text-align: center;
  width: 100%;
  margin: 3px 0px;
  border-bottom: 1px solid black;
}
[data-kermit-document] .kd[data-kd-mode=view] .kp[data-kt=image] .kpv .kpv-raw {
  display: none;
}
[data-kermit-document] .kd[data-kd-mode=view] .kp[data-kp-visibility=edit_only] {
  display: none;
}
[data-kermit-document] .kp-hint {
  display: none;
  font-size: 13px;
}
[data-kermit-document] .kp-error {
  display: none;
  color: #D43341;
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
[data-kermit-document] .kd[data-kd-mode=edit] {
  /*
  .kpv[data-kt-choice="false"][data-kt-allowmultiple="true"] {
    .kpv-input-add {
      display: flex;
      align-items: center;
    }

    .kpv-values {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      margin-top: 5px;
      gap: 5px;
    }

    .kpv-value {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .kpv-value-remove {
      display: inline-flex;
      align-items: center;
    }

    .kpv-input-add-label {
      display: none;
    }
    .kpv-value-remove-label {
      display: none;
    }
  }
  */
}
[data-kermit-document] .kd[data-kd-mode=edit] .kd-submit {
  display: flex;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kd-result[data-kd-error] {
  display: flex;
  color: #D43341;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kd-result[data-kd-error] .k-success-icon {
  display: none;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kd-result[data-kd-error]:after {
  margin-left: 4px;
  content: attr(data-kd-error);
}
[data-kermit-document] .kd[data-kd-mode=edit] .kd-result[data-kd-success] {
  display: flex;
  color: #039855;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kd-result[data-kd-success] .k-error-icon {
  display: none;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kd-result[data-kd-success]:after {
  margin-left: 4px;
  content: attr(data-kd-success);
}
[data-kermit-document] .kd[data-kd-mode=edit] [data-kp-required=true] > .kp-name label:first-child:after {
  content: " *";
  color: #D43341;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp-name {
  display: inline-flex;
  justify-content: space-between;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp-error[data-kp-error] {
  display: flex;
  align-items: center;
  gap: 4px;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp-error[data-kp-error]:before {
  content: attr(data-kp-error);
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp-hint {
  display: block;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kpv {
  width: 100%;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kpv-raw {
  display: none;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kpv-input {
  display: flex;
  align-items: center;
  gap: 5px;
  width: 100%;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kpv-input .kpv-input-add {
  display: none;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kt {
  display: none;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kp-edit-state=open] .ks-header .ks-remove {
  display: inline-flex;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kp-edit-state=open] .ks-add {
  display: block;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kp-edit-state=locked] .kpv-input {
  display: none;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kp-edit-state=locked] .kpv-values {
  display: block;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kp-edit-state=locked] .kpv-values button {
  display: none;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=image] .kpv .kpv-input, [data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=file] .kpv .kpv-input {
  display: flex;
  flex-direction: row;
  height: auto;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=image] .kpv .kpv-input .kpv-input-add, [data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=file] .kpv .kpv-input .kpv-input-add {
  display: none;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=image] .kpv-input-box, [data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=file] .kpv-input-box {
  visibility: hidden;
  display: none;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=image] .kpv-image-input, [data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=image] .kpv-file-input, [data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=file] .kpv-image-input, [data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=file] .kpv-file-input {
  width: calc(100% - 20px);
  max-width: 1000px;
  height: 43px;
  visibility: visible;
  display: block;
  border-radius: 6px;
  border: 1px dashed rgba(0, 0, 0, 0.2);
  background-color: #FFF;
  padding: 8px;
  text-align: center;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=image] .kpv-image-input label, [data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=image] .kpv-file-input label, [data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=file] .kpv-image-input label, [data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=file] .kpv-file-input label {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  color: rgba(0, 0, 0, 0.7);
  gap: 4px;
  font-size: 13px;
  font-family: Poppins;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=image] .kpv-image-input label .kpv-upload-title, [data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=image] .kpv-file-input label .kpv-upload-title, [data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=file] .kpv-image-input label .kpv-upload-title, [data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=file] .kpv-file-input label .kpv-upload-title {
  font-weight: 600;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=image] .dropping .kpv-image-input, [data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=file] .dropping .kpv-image-input {
  background-color: rgba(0, 0, 0, 0.2);
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=image] .kpv-image-input-box, [data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=image] .kpv-file-input-box, [data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=file] .kpv-image-input-box, [data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=file] .kpv-file-input-box {
  opacity: 0;
  height: 0%;
  width: 100%;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=image] .kpv-values .kpv-value {
  position: relative;
  height: 190px;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=image] .kpv-values .kpv-value .k-spinner {
  position: absolute;
  top: 50px;
  left: 50px;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=image] .kpv-values .kpv-value[data-kp-value] .kpv-value-remove {
  display: block;
  position: absolute;
  top: 5px;
  right: 5px;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=image] .kpv-values .kpv-value[data-kp-value] .kpv-value-remove .kpv-value-remove-label {
  display: none;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=file] .kpv-values .kpv-value[data-kp-value] .kpv-value-remove {
  display: inline;
  margin-right: 5px;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=file] .kpv-values .kpv-value[data-kp-value] .kpv-value-remove .kpv-value-remove-label {
  display: none;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kpv[data-kt-choice=true] .kpv-input {
  display: none;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kpv[data-kt-choice=true] .kt {
  display: block;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kpv[data-kt-choice=true][data-kt-uniquevalues=true] .kt-option, [data-kermit-document] .kd[data-kd-mode=edit] .kpv[data-kt-choice=true][data-kt-uniquevalues=false][data-kt-allowmultiple=false] .kt-option {
  display: flex;
  align-items: center;
  margin-top: 8px;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kpv[data-kt-choice=true][data-kt-uniquevalues=true] .kt-option .kt-option-add, [data-kermit-document] .kd[data-kd-mode=edit] .kpv[data-kt-choice=true][data-kt-uniquevalues=false][data-kt-allowmultiple=false] .kt-option .kt-option-add {
  width: 22px;
  margin-right: 8px;
  content: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
[data-kermit-document] .kd[data-kd-mode=edit] .kpv[data-kt-choice=true][data-kt-uniquevalues=true] .kt-option .kt-option-value, [data-kermit-document] .kd[data-kd-mode=edit] .kpv[data-kt-choice=true][data-kt-uniquevalues=false][data-kt-allowmultiple=false] .kt-option .kt-option-value {
  font-weight: 600;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kpv[data-kt-choice=true][data-kt-uniquevalues=true] .kt-option[data-kt-option-selected="0"] .kt-option-add, [data-kermit-document] .kd[data-kd-mode=edit] .kpv[data-kt-choice=true][data-kt-uniquevalues=false][data-kt-allowmultiple=false] .kt-option[data-kt-option-selected="0"] .kt-option-add {
  width: 22px;
  margin-right: 8px;
  content: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
[data-kermit-document] .kd[data-kd-mode=edit] .kpv[data-kt-choice=true][data-kt-uniquevalues=true] .kt-option[data-kt-option-selected="0"] .kt-option-value, [data-kermit-document] .kd[data-kd-mode=edit] .kpv[data-kt-choice=true][data-kt-uniquevalues=false][data-kt-allowmultiple=false] .kt-option[data-kt-option-selected="0"] .kt-option-value {
  font-weight: 400;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kpv[data-kt-choice=true][data-kt-uniquevalues=false][data-kt-allowmultiple=true] .kpv-raw {
  display: block;
  padding-bottom: 5px;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kpv[data-kt-choice=true][data-kt-uniquevalues=false][data-kt-allowmultiple=true] .kt-option:before {
  content: "(" attr(data-kt-option-selected) ")";
  width: 30px;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kpv[data-kt-choice=true][data-kt-uniquevalues=false][data-kt-allowmultiple=true] .kt-option {
  display: flex;
  align-items: center;
  gap: 2px;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kpv[data-kt-choice=true][data-kt-uniquevalues=false][data-kt-allowmultiple=true] .kt-option .kt-option-add {
  width: 22px;
  content: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
[data-kermit-document] .kd[data-kd-mode=edit] .kpv[data-kt-choice=true][data-kt-uniquevalues=false][data-kt-allowmultiple=true] .kt-option .kt-option-remove {
  width: 22px;
  content: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
[data-kermit-document] .kd[data-kd-mode=edit] .kpv[data-kt-choice=true][data-kt-uniquevalues=false][data-kt-allowmultiple=true] .kt-option .kt-option-value {
  font-weight: 600;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kpv[data-kt-choice=true][data-kt-uniquevalues=false][data-kt-allowmultiple=true] .kt-option[data-kt-option-selected="0"] .kt-option-value {
  font-weight: 400;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=markdown] .kpv-raw {
  display: block;
  color: rgba(49, 90, 183, 0.8);
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=markdown] .kpv-raw h1, [data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=markdown] .kpv-raw h2, [data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=markdown] .kpv-raw h3, [data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=markdown] .kpv-raw h4 {
  color: #315AB7;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=markdown] .kpv .kpv-input {
  display: none;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=markdown] .kpv .kpv-values {
  display: none;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=minor_break] {
  width: 100%;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=minor_break] .kpv-raw {
  display: block;
  width: 100%;
  margin: 3px 0px;
  border-bottom: 1px solid black;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=minor_break] .kpv .kpv-input {
  display: none;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=minor_break] .kpv .kpv-values {
  display: none;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=major_break] {
  width: 100%;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=major_break] .kpv-raw {
  display: block;
  width: 100%;
  margin: 3px 0px;
  border-bottom: 1px dashed rgba(41, 145, 237, 0.2);
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=major_break] .kpv .kpv-input {
  display: none;
}
[data-kermit-document] .kd[data-kd-mode=edit] .kp[data-kt=major_break] .kpv .kpv-values {
  display: none;
}
[data-kermit-document] .kd[data-kd-mode=build] .kpv-raw {
  display: none;
}
[data-kermit-document] .kd[data-kd-mode=build] .kpv-input {
  visibility: visible;
  display: block;
}
[data-kermit-document] .kd[data-kd-mode=build] .kt {
  display: block;
}
[data-kermit-document] .kps, [data-kermit-document] .ks-parts {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  column-gap: 10px;
  row-gap: 24px;
  width: 100%;
  font-family: Poppins;
  font-size: 1em;
  font-style: normal;
  line-height: normal;
  color: rgba(0, 0, 0, 0.6);
}
[data-kermit-document] .kp {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  width: calc(50% - 12px);
  max-width: 100%;
  min-width: min(100vw - 24px, 200px);
  flex-grow: 1;
  font-weight: 400;
}
[data-kermit-document] .kp-name {
  font-weight: 700;
  color: rgba(0, 0, 0, 0.7);
  width: 100%;
}
[data-kermit-document] .ks-header {
  width: 100%;
  margin: 24px 0 12px 0;
  display: flex;
  align-items: center;
  gap: 24px;
}
[data-kermit-document] .ks-header .ks-name {
  font-weight: 700;
  font-family: "Poppins";
  color: #315AB7;
}
[data-kermit-document] .ks-header .ks-remove {
  display: none;
  align-items: center;
  gap: 4px;
  padding: 0px;
  border: none;
  background: none;
  color: #D43341;
  font-family: "Poppins";
  font-size: 16px;
  font-weight: 400;
}
[data-kermit-document] .kpdc-mini-section .kp-section .kp-name {
  font-weight: 500;
  font-size: 0.8em;
}
[data-kermit-document] .kpdc-light .kp-name {
  color: rgba(0, 0, 0, 0.6);
}
[data-kermit-document] .kpdc-full-width {
  width: 100%;
}
[data-kermit-document] .kpdc-full-width .kp-name {
  width: 100%;
}
[data-kermit-document] .kpdc-small-width {
  width: calc(25% - 12px);
}
[data-kermit-document] .kpdc-center .kpv-raw {
  text-align: center;
}
[data-kermit-document] .kd[data-kd-mode=view] .kp[data-kp-empty=true] {
  display: none;
}
[data-kermit-document] .kd[data-kd-mode=view] .kp[data-kp-empty=true][data-kt=minor_break] {
  display: block;
}
[data-kermit-document] .kd[data-kd-mode=view] .kp.kpdc-placeholder-empty[data-kp-empty=true] .kpv-raw:before {
  display: flex;
  content: "Not provided";
}
[data-kermit-document] .kp[data-kp-visibility=hidden] {
  display: none;
}
[data-kermit-document] .kp-sections {
  width: 100%;
}
[data-kermit-document] .kp-sections .kp-section {
  width: 100%;
  margin-top: 12px;
}
[data-kermit-document] .ks-add-section {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
[data-kermit-document] .ks-add-section .ks-add {
  display: none;
  padding: 0px;
  border: none;
  background: none;
  color: #2991ED;
  font-family: "Poppins";
  font-weight: 400;
}
[data-kermit-document] .kpdc-numbered {
  counter-reset: section;
}
[data-kermit-document] .kpdc-numbered .kp-section {
  counter-increment: section;
}
[data-kermit-document] .kpdc-numbered .kp-section .ks-name::after {
  content: " #" counter(section);
}
[data-kermit-document] .kpdc-not-required[data-kp-required=true] > .kp-name span:first-child:after {
  content: "";
}

[data-kermit-document][data-kermit-debug=true] .kd-source, [data-kermit-document][data-kermit-debug=true] .kp-source {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/embed.scss"],"names":[],"mappings":"AAAA;EA8yBE;;;;;;;;;;;;;GAAA;AA/xBF;AAdE;EACE,aAAA;AAgBJ;AAbE;EACE,YAAA;EACA,SAAA;EACA,UAAA;AAeJ;AAZE;EACE,UAAA;EACA,YAAA;AAcJ;AAXE;EACE,cAAA;EACA,iBAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;EAEA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,2CAAA;AAYJ;AARI;EACE,mBAAA;EACA;;GAAA;AAYN;AAPI;EACE,iBAAA;AASN;AALE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;AAOJ;AAJE;EACE,aAAA;AAMJ;AAHE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAKJ;AAFE;EACE,cAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAIJ;AADE;EACE,aAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AAGJ;AADI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,qDAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;AAGN;AAAI;EACE,iHAAA;AAEN;AAEE;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAAJ;AAGE;EACE,2BAAA;EACA,sBAAA;EACA,4BAAA;AADJ;AAGE;EACE,0BAAA;EACA,sBAAA;EACA,4BAAA;AADJ;AAIE;EACE;IACE,sBAAA;EAFJ;EAIE;IACE,sBAAA;EAFJ;EAIE;IACE,sBAAA;EAFJ;AACF;AAKE;EACE;IACE,sBAAA;EAHJ;EAKE;IACE,sBAAA;EAHJ;EAKE;IACE,sBAAA;EAHJ;AACF;AAME;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAJJ;AAME;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;AAJJ;AAME;EACE,sBAAA;EACA,kBAAA;EACA,YAAA;AAJJ;AAME;EACE,sBAAA;EACA,kBAAA;EACA,YAAA;AAJJ;AAME;EACE,0BAAA;AAJJ;AAME;EACE,0BAAA;AAJJ;AAME;EACE,kBAAA;AAJJ;AAME;EACE,WAAA;AAJJ;AAME;EACE,gBAAA;AAJJ;AAOE;EACE,gDAAA;AALJ;AAOE;EACE,gDAAA;AALJ;AAOE;EACE,gDAAA;AALJ;AAQE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AANJ;AAQI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,2DAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;AANN;AAUE;EACE,WAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,2CAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AARJ;AAUE;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;AARJ;AAUE;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;AARJ;AAWE;EACE,aAAA;AATJ;AAYE;EACE,YAAA;EACA,aAAA;EACA,iBAAA;AAVJ;AAaE;EACE,WAAA;EACA,gDAAA;AAXJ;AAcE;EACE,WAAA;EACA,gDAAA;AAZJ;AAgBI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AAdN;AAgBM;EACE,aAAA;AAdR;AAiBM;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAfR;AAiBQ;EACE,aAAA;AAfV;AAsBI;EACE,cAAA;AApBN;AAsBI;EACE,cAAA;EACA,aAAA;AApBN;AAsBI;EACE,kBAAA;EACA,aAAA;AApBN;AAsBI;EACE,aAAA;AApBN;AAuBI;EACE,WAAA;AArBN;AAuBM;EACE,WAAA;AArBR;AAwBM;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,8BAAA;AAtBR;AA0BI;EACE,aAAA;AAxBN;AA2BI;EACE,aAAA;AAzBN;AA6BE;EACE,aAAA;EACA,eAAA;AA3BJ;AA6BE;EACE,aAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA3BJ;AA8BE;EAyPE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAAA;AAlPJ;AANI;EACE,aAAA;AAQN;AALI;EACE,aAAA;EACA,cAAA;AAON;AALM;EACE,aAAA;AAOR;AAJI;EACE,gBAAA;EACA,4BAAA;AAMN;AAJI;EACE,aAAA;EACA,cAAA;AAMN;AAJM;EACE,aAAA;AAMR;AAHI;EACE,gBAAA;EACA,8BAAA;AAKN;AAFI;EACE,aAAA;EACA,cAAA;AAIN;AAFI;EACE,oBAAA;EACA,8BAAA;AAIN;AAFI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAIN;AAFI;EACE,4BAAA;AAIN;AAFI;EACE,cAAA;AAIN;AADI;EACE,WAAA;AAGN;AADI;EACE,aAAA;AAGN;AADI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AAGN;AADM;EACE,aAAA;AAGR;AAAI;EACE,aAAA;AAEN;AACI;EACE,oBAAA;AACN;AACI;EACE,cAAA;AACN;AACI;EACE,aAAA;AACN;AACI;EAIE,cAAA;AAFN;AADM;EACE,aAAA;AAGR;AAGM;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AADR;AAGQ;EACE,aAAA;AADV;AAIM;EACE,kBAAA;EACA,aAAA;AAFR;AAIM;EACE,wBAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,qCAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;AAFR;AAIQ;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,QAAA;EACA,eAAA;EACA,oBAAA;AAFV;AAIU;EACE,gBAAA;AAFZ;AAMM;EACE,oCAAA;AAJR;AAMM;EACE,UAAA;EACA,UAAA;EACA,WAAA;AAJR;AASM;EACE,kBAAA;EACA,aAAA;AAPR;AASQ;EACE,kBAAA;EACA,SAAA;EACA,UAAA;AAPV;AAYQ;EACE,cAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AAVV;AAYU;EACE,aAAA;AAVZ;AAkBQ;EACE,eAAA;EACA,iBAAA;AAhBV;AAkBU;EACE,aAAA;AAhBZ;AAuBM;EACE,aAAA;AArBR;AAuBM;EACE,cAAA;AArBR;AAyBM;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AAvBR;AAyBQ;EACE,WAAA;EACA,iBAAA;EACA,gDAAA;AAvBV;AA0BQ;EACE,gBAAA;AAxBV;AA6BQ;EACE,WAAA;EACA,iBAAA;EACA,gDAAA;AA3BV;AA8BQ;EACE,gBAAA;AA5BV;AAiCM;EACE,cAAA;EACA,mBAAA;AA/BR;AAiCM;EACE,8CAAA;EACA,WAAA;AA/BR;AAiCM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA/BR;AAiCQ;EACE,WAAA;EACA,gDAAA;AA/BV;AAiCQ;EACE,WAAA;EACA,gDAAA;AA/BV;AAmCQ;EACE,gBAAA;AAjCV;AAsCQ;EACE,gBAAA;AApCV;AAgFM;EACE,cAAA;EAIA,6BAAA;AAjFR;AAkFQ;EACE,cAAA;AAhFV;AAmFM;EACE,aAAA;AAjFR;AAmFM;EACE,aAAA;AAjFR;AAqFI;EACE,WAAA;AAnFN;AAqFM;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,8BAAA;AAnFR;AAqFM;EACE,aAAA;AAnFR;AAqFM;EACE,aAAA;AAnFR;AAsFI;EACE,WAAA;AApFN;AAsFM;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,iDAAA;AApFR;AAsFM;EACE,aAAA;AApFR;AAsFM;EACE,aAAA;AApFR;AA0FI;EACE,aAAA;AAxFN;AA0FI;EACE,mBAAA;EACA,cAAA;AAxFN;AA0FI;EACE,cAAA;AAxFN;AA4FE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,oBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AA1FJ;AA6FE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,uBAAA;EACA,eAAA;EACA,mCAAA;EACA,YAAA;EACA,gBAAA;AA3FJ;AA+FE;EACE,gBAAA;EACA,yBAAA;EACA,WAAA;AA7FJ;AAgGE;EACE,WAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AA9FJ;AAgGI;EACE,gBAAA;EACA,sBAAA;EACA,cAAA;AA9FN;AAgGI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;AA9FN;AAmGI;EACE,gBAAA;EACA,gBAAA;AAjGN;AAqGE;EACE,yBAAA;AAnGJ;AAsGE;EACE,WAAA;AApGJ;AAqGI;EACE,WAAA;AAnGN;AAuGE;EACE,uBAAA;AArGJ;AAyGI;EACE,kBAAA;AAvGN;AA4GI;EACE,aAAA;AA1GN;AA6GI;EACE,cAAA;AA3GN;AA8GI;EACE,aAAA;EACA,uBAAA;AA5GN;AA+HE;EACE,aAAA;AA7HJ;AAgIE;EACE,WAAA;AA9HJ;AA+HI;EACE,WAAA;EACA,gBAAA;AA7HN;AAiIE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AA/HJ;AAiII;EACE,aAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;AA/HN;AAmIE;EACE,sBAAA;AAjIJ;AAkII;EACE,0BAAA;AAhIN;AAiIM;EACE,8BAAA;AA/HR;AAoIE;EACE,WAAA;AAlIJ;;AAuIE;EACE,cAAA;AApIJ","sourcesContent":["[data-kermit-document] {\n  .kd-source, .kp-source {\n    display: none;\n  }\n\n  fieldset {\n    border: none;\n    margin: 0;\n    padding: 0;\n  }\n\n  legend {\n    opacity: 0;\n    font-size: 0;\n  }\n\n  .kt-options select {\n    display: block;\n    user-select: none;\n    cursor: pointer;\n    box-sizing: content-box;\n    background: none;\n\n    width: 100%;\n    min-height: 24px;\n    font-size: 1em;\n    font-weight: 400;\n    letter-spacing: 0.033px;\n    font-family: 'Poppins';\n    padding: 0;\n    border: 0;\n    border-radius: 0;\n    border-bottom: 1px solid #00000033;\n  }\n\n  .kpv-input {\n    input:focus, textarea:focus {\n      outline-style: none;\n      /*\n      background-color: #00000022;\n      */\n    }\n    \n    textarea {\n      max-height: 9.5em;\n    }\n  }\n  \n  .kd {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    row-gap: 25px;\n  }\n\n  .kp.kp-cond-hidden {\n    display: none;\n  }\n  \n  .kd-header {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n  }\n  \n  .kd-name {\n    color: #315AB7;\n    font-family: Haboro Soft, sans-serif;\n    font-size: 1.5em;\n    font-style: normal;\n    font-weight: 900;\n    line-height: normal;\n    letter-spacing: 0.033px;\n  }\n\n  .kd-submit {\n    display: none;\n    width: 100%;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n\n    button {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 300px;\n      height: 48px;\n      padding: 12px 16px;\n      border-radius: 8px;\n      border: none;\n      background: var(--primary-cerulean-blue-100, #2991ED);\n      color: #FFFFFF;\n      font-family: 'Poppins';\n      font-weight: 500;\n    }\n\n    button:disabled {\n      background: linear-gradient(0deg, rgba(0, 0, 0, 0.10) 0%, rgba(0, 0, 0, 0.10) 100%), var(--common-white-main, #FFF);\n    }\n  }\n\n  .kd-result {\n    display: none;\n    width: 100%;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    font-family: Poppins;\n    font-size: 13px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n  \n  .kd[data-kd-saving=\"saved\"] {\n    animation-name: saveSuccess;\n    animation-duration: 3s;\n    animation-iteration-count: 1;\n  }\n  .kd[data-kd-saving=\"failed\"] {\n    animation-name: saveFailed;\n    animation-duration: 3s;\n    animation-iteration-count: 1;\n  }\n  \n  @keyframes saveSuccess {\n    0% {\n      background-color: #FFF;\n    }\n    50% {\n      background-color: #BFB;\n    }\n    100% {\n      background-color: #FFF;\n    }\n  }\n  \n  @keyframes saveFailed {\n    0% {\n      background-color: #FFF;\n    }\n    50% {\n      background-color: #FBB;\n    }\n    100% {\n      background-color: #FFF;\n    }\n  }\n  \n  .kd-controls {\n    display: flex;\n    flex-direction: row;\n    align-items: top;\n  }\n  .kd-control {\n    display: inline-flex;\n    align-items: center;\n    gap: 3px;\n    border-radius: 0;\n    padding: 3px;\n    border-radius: 0px;\n    border: 1px solid #333;\n    margin-right: -1px;\n    background-color: #FFF;\n  }\n  .kd-control[data-kd-selected-mode] {\n    background-color: #CCC;\n    border-color: #000;\n    z-index: 888;\n  }\n  .kd-control:hover {\n    background-color: #EEE;\n    border-color: #888;\n    z-index: 999;\n  }\n  .kd-control:first-child {\n    border-radius: 5px 0 0 5px;\n  }\n  .kd-control:last-child {\n    border-radius: 0 5px 5px 0;\n  }\n  .kd-control:only-child {\n    border-radius: 5px;\n  }\n  .kd-control .kd-control-icon {\n    width: 22px;\n  }\n  .kd-control .kd-control-label {\n    font-weight: 600;\n  }\n  \n  .kd-control[data-kd-mode-control=\"view\"] .kd-control-icon {\n    content: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root\" focusable=\"false\" aria-hidden=\"true\" viewBox=\"0 0 24 24\" data-testid=\"VisibilityIcon\"><path d=\"M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z\"></path></svg>');\n  }\n  .kd-control[data-kd-mode-control=\"edit\"] .kd-control-icon {\n    content: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root\" focusable=\"false\" aria-hidden=\"true\" viewBox=\"0 0 24 24\" data-testid=\"EditIcon\"><path d=\"M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z\"></path></svg>');\n  }\n  .kd-control[data-kd-mode-control=\"build\"] .kd-control-icon {\n    content: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root\" focusable=\"false\" aria-hidden=\"true\" viewBox=\"0 0 24 24\" data-testid=\"BuildIcon\"><path d=\"m22.7 19-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z\"></path></svg>');\n  }\n\n  .kp-next {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n\n    button {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      height: 48px;\n      width: 300px;\n      padding: 12px 16px;\n      border-radius: 8px;\n      border: 1px solid var(--primary-cerulean-blue-100, #2991ED);\n      background: none;\n      color: #2991ED;\n      font-family: 'Poppins';\n      font-weight: 500;\n    }\n  }\n  \n  .kpv-input-box {\n    width: 100%;\n    min-height: 24px;\n    font-size: 1em;\n    font-weight: 400;\n    letter-spacing: 0.033px;\n    font-family: 'Poppins';\n    padding: 0;\n    border: 0;\n    border-bottom: 1px solid #00000033;\n    box-sizing: border-box;\n    background: none;\n    resize: none;\n    overflow: hidden;\n  }\n  .kpv-image-input {\n    visibility: hidden;\n    display: none;\n    box-sizing: content-box;\n  }\n  .kpv-file-input {\n    visibility: hidden;\n    display: none;\n    box-sizing: content-box;\n  }\n  \n  .kpv-values {\n    display: none;\n  }\n  \n  .kpv-value-image {\n    width: 190px;\n    height: 190px;\n    object-fit: cover;\n  }\n  \n  .kpv-input-add-icon {\n    width: 18px;\n    content: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root\" focusable=\"false\" aria-hidden=\"true\" viewBox=\"0 0 24 24\" data-testid=\"AddIcon\"><path d=\"M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z\"></path></svg>');\n  }\n  \n  .kpv-value-remove-icon {\n    width: 18px;\n    content: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root\" focusable=\"false\" aria-hidden=\"true\" viewBox=\"0 0 24 24\" data-testid=\"RemoveIcon\"><path d=\"M19 13H5v-2h14v2z\"></path></svg>');\n  }\n  \n  .kp[data-kt=\"image\"], .kp[data-kt=\"file\"] {\n    .kpv {\n      display: flex;\n      flex-direction: row;\n      flex-wrap: wrap;\n      width: 100%;\n      height: auto;\n      row-gap: 10px;\n      column-gap: 10px;\n  \n      .kpv-raw {\n        display: none;\n      }\n  \n      .kpv-values {\n        display: flex;\n        flex-direction: row;\n        flex-wrap: nowrap;\n        overflow: scroll;\n        width: 100%;\n        height: auto;\n        column-gap: 5px;\n  \n        .kpv-value-remove {\n          display: none;\n        }\n      }\n    }\n  }\n  \n  .kd[data-kd-mode=\"view\"] {\n    .kpv-raw {\n      display: block;\n    }\n    .kpv-values {\n      display: block;\n      display: none;\n    }\n    .kpv-input {\n      visibility: hidden;\n      display: none;\n    }\n    .kt {\n      display: none;\n    }\n  \n    .kp[data-kt=\"minor_break\"], .kp[data-kt=\"major_break\"] {\n      width: 100%;\n  \n      .kpv {\n        width: 100%;\n      }\n  \n      .kpv-raw {\n        text-align: center;\n        width: 100%;\n        margin: 3px 0px;\n        border-bottom: 1px solid black;\n      }\n    }\n  \n    .kp[data-kt=\"image\"] .kpv .kpv-raw {\n      display: none;\n    }\n\n    .kp[data-kp-visibility=\"edit_only\"] {\n      display: none;\n    }\n  }\n\n  .kp-hint {\n    display: none;\n    font-size: 13px;\n  }\n  .kp-error {\n    display: none;\n    color: #D43341;\n    font-family: Poppins;\n    font-size: 13px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n  \n  .kd[data-kd-mode=\"edit\"] {\n    .kd-submit {\n      display: flex;\n    }\n\n    .kd-result[data-kd-error] {\n      display: flex;\n      color: #D43341;\n\n      .k-success-icon {\n        display: none;\n      }\n    }\n    .kd-result[data-kd-error]:after {\n      margin-left: 4px;\n      content: attr(data-kd-error);\n    }\n    .kd-result[data-kd-success] {\n      display: flex;\n      color: #039855;\n\n      .k-error-icon {\n        display: none;\n      }\n    }\n    .kd-result[data-kd-success]:after {\n      margin-left: 4px;\n      content: attr(data-kd-success);\n    }\n\n    [data-kp-required=\"true\"] > .kp-name label:first-child:after {\n      content: \" *\";\n      color: #D43341;\n    }\n    .kp-name {\n      display: inline-flex;\n      justify-content: space-between;\n    }\n    .kp-error[data-kp-error] {\n      display: flex;\n      align-items: center;\n      gap: 4px;\n    }\n    .kp-error[data-kp-error]:before {\n      content: attr(data-kp-error);\n    }\n    .kp-hint {\n      display: block;\n    }\n\n    .kpv {\n      width: 100%;\n    }\n    .kpv-raw {\n      display: none;\n    }\n    .kpv-input {\n      display: flex;\n      align-items: center;\n      gap: 5px;\n      width: 100%;\n  \n      .kpv-input-add {\n        display: none;\n      }\n    }\n    .kt {\n      display: none;\n    }\n\n    .kp[data-kp-edit-state=\"open\"] .ks-header .ks-remove {\n      display: inline-flex;\n    }\n    .kp[data-kp-edit-state=\"open\"] .ks-add {\n      display: block;\n    }\n    .kp[data-kp-edit-state=\"locked\"] .kpv-input {\n      display: none;\n    }\n    .kp[data-kp-edit-state=\"locked\"] .kpv-values {\n      button {\n        display: none;\n      }\n      display: block;\n    }\n  \n    .kp[data-kt=\"image\"], .kp[data-kt=\"file\"] {\n      .kpv .kpv-input {\n        display: flex;\n        flex-direction: row;\n        height: auto;\n\n        .kpv-input-add {\n          display: none;\n        }\n      }\n      .kpv-input-box {\n        visibility: hidden;\n        display: none;\n      }\n      .kpv-image-input, .kpv-file-input {\n        width: calc(100% - 20px);\n        max-width: 1000px;\n        height: 43px;\n        visibility: visible;\n        display: block;\n        border-radius: 6px;\n        border: 1px dashed #00000033;\n        background-color: #FFF;\n        padding: 8px;\n        text-align: center;\n        \n        label {\n          height: 100%;\n          width: 100%;\n          display: flex;\n          flex-direction: column;\n          color: rgba(0, 0, 0, 0.7);\n          gap: 4px;\n          font-size: 13px;\n          font-family: Poppins;\n  \n          .kpv-upload-title {\n            font-weight: 600;\n          }\n        }\n      }\n      .dropping .kpv-image-input {\n        background-color: #00000033;\n      }\n      .kpv-image-input-box, .kpv-file-input-box {\n        opacity: 0;\n        height: 0%;\n        width: 100%;\n      }\n    }\n\n    .kp[data-kt=\"image\"] .kpv-values {\n      .kpv-value {\n        position: relative;\n        height: 190px;\n  \n        .k-spinner {\n          position: absolute;\n          top: 50px;\n          left: 50px;\n        }\n      }\n\n      .kpv-value[data-kp-value] {\n        .kpv-value-remove {\n          display: block;\n          position: absolute;\n          top: 5px;\n          right: 5px;\n  \n          .kpv-value-remove-label {\n            display: none;\n          }\n        }\n      }\n    }\n\n    .kp[data-kt=\"file\"] .kpv-values {\n      .kpv-value[data-kp-value] {\n        .kpv-value-remove {\n          display: inline;\n          margin-right: 5px;\n  \n          .kpv-value-remove-label {\n            display: none;\n          }\n        }\n      }\n    }\n  \n    .kpv[data-kt-choice=\"true\"] {\n      .kpv-input {\n        display: none;\n      }\n      .kt {\n        display: block;\n      }\n    }\n    .kpv[data-kt-choice=\"true\"][data-kt-uniquevalues=\"true\"], .kpv[data-kt-choice=\"true\"][data-kt-uniquevalues=\"false\"][data-kt-allowmultiple=\"false\"] {\n      .kt-option {\n        display: flex;\n        align-items: center;\n        margin-top: 8px;\n  \n        .kt-option-add {\n          width: 22px;\n          margin-right: 8px;\n          content: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\" viewBox=\"0 0 24 24\" data-testid=\"CheckBoxIcon\"><path d=\"M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z\"></path></svg>');\n        }\n        \n        .kt-option-value {\n          font-weight: 600;\n        }\n      }\n  \n      .kt-option[data-kt-option-selected=\"0\"] {\n        .kt-option-add {\n          width: 22px;\n          margin-right: 8px;\n          content: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\" viewBox=\"0 0 24 24\" data-testid=\"CheckBoxOutlineBlankIcon\"><path d=\"M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z\"></path></svg>');\n        }\n        \n        .kt-option-value {\n          font-weight: 400;\n        }\n      }\n    }\n    .kpv[data-kt-choice=\"true\"][data-kt-uniquevalues=\"false\"][data-kt-allowmultiple=\"true\"] {\n      .kpv-raw {\n        display: block;\n        padding-bottom: 5px;\n      }\n      .kt-option:before {\n        content: '(' attr(data-kt-option-selected) ')';\n        width: 30px;\n      }\n      .kt-option {\n        display: flex;\n        align-items: center;\n        gap: 2px;\n  \n        .kt-option-add {\n          width: 22px;\n          content: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root\" focusable=\"false\" aria-hidden=\"true\" viewBox=\"0 0 24 24\" data-testid=\"AddIcon\"><path d=\"M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z\"></path></svg>');\n        }\n        .kt-option-remove {\n          width: 22px;\n          content: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root\" focusable=\"false\" aria-hidden=\"true\" viewBox=\"0 0 24 24\" data-testid=\"RemoveIcon\"><path d=\"M19 13H5v-2h14v2z\"></path></svg>');\n        }\n        \n        \n        .kt-option-value {\n          font-weight: 600;\n        }\n      }\n  \n      .kt-option[data-kt-option-selected=\"0\"] {\n        .kt-option-value {\n          font-weight: 400;\n        }\n      }\n    }\n  \n    /*\n    .kpv[data-kt-choice=\"false\"][data-kt-allowmultiple=\"true\"] {\n      .kpv-input-add {\n        display: flex;\n        align-items: center;\n      }\n  \n      .kpv-values {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: flex-start;\n        margin-top: 5px;\n        gap: 5px;\n      }\n  \n      .kpv-value {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n      }\n  \n      .kpv-value-remove {\n        display: inline-flex;\n        align-items: center;\n      }\n  \n      .kpv-input-add-label {\n        display: none;\n      }\n      .kpv-value-remove-label {\n        display: none;\n      }\n    }\n    */\n  \n    .kp[data-kt=\"markdown\"] {\n      // width: 100%;\n  \n      .kpv-raw {\n        display: block;\n        // text-align: center;\n        // width: 100%;\n\n        color: #315AB7CC;\n        h1, h2, h3, h4 {\n          color: #315AB7;\n        }\n      }\n      .kpv .kpv-input {\n        display: none;\n      }\n      .kpv .kpv-values {\n        display: none;\n      }\n    }\n    \n    .kp[data-kt=\"minor_break\"] {\n      width: 100%;\n  \n      .kpv-raw {\n        display: block;\n        width: 100%;\n        margin: 3px 0px;\n        border-bottom: 1px solid black;\n      }\n      .kpv .kpv-input {\n        display: none;\n      }\n      .kpv .kpv-values {\n        display: none;\n      }\n    }\n    .kp[data-kt=\"major_break\"] {\n      width: 100%;\n  \n      .kpv-raw {\n        display: block;\n        width: 100%;\n        margin: 3px 0px;\n        border-bottom: 1px dashed #2991ED33;\n      }\n      .kpv .kpv-input {\n        display: none;\n      }\n      .kpv .kpv-values {\n        display: none;\n      }\n    }\n  }\n  \n  .kd[data-kd-mode=\"build\"] {\n    .kpv-raw {\n      display: none;\n    }\n    .kpv-input {\n      visibility: visible;\n      display: block;\n    }\n    .kt {\n      display: block;\n    }\n  }\n  \n  .kps, .ks-parts {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    column-gap: 10px;\n    row-gap: 24px;\n    width: 100%;\n    font-family: Poppins;\n    font-size: 1em;\n    font-style: normal;\n    line-height: normal;\n    color: rgba(0, 0, 0, 0.6);\n  }\n  \n  .kp {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n    width: calc(50% - 12px);\n    max-width: calc(100%);\n    min-width: min(calc(100vw - 24px), 200px);\n    flex-grow: 1;\n    font-weight: 400;\n  }\n\n  \n  .kp-name {\n    font-weight: 700;\n    color: rgba(0, 0, 0, 0.7);\n    width: 100%;\n  }\n\n  .ks-header {\n    width: 100%;\n    margin: 24px 0 12px 0;\n    display: flex;\n    align-items: center;\n    gap: 24px;\n\n    .ks-name {\n      font-weight: 700;\n      font-family: \"Poppins\";\n      color: #315AB7;\n    }\n    .ks-remove {\n      display: none;\n      align-items: center;\n      gap: 4px;\n      padding: 0px;\n      border: none;\n      background: none;\n      color: #D43341;\n      font-family: 'Poppins';\n      font-size: 16px;\n      font-weight: 400;\n    }\n  }\n\n  .kpdc-mini-section .kp-section {\n    .kp-name {\n      font-weight: 500;\n      font-size: 0.8em;\n    }\n  }\n\n  .kpdc-light .kp-name {\n    color: rgba(0, 0, 0, 0.6);\n  }\n  \n  .kpdc-full-width {\n    width: 100%;\n    .kp-name {\n      width: 100%;\n    }\n  }\n\n  .kpdc-small-width {\n    width: calc(25% - 12px);\n  }\n\n  .kpdc-center {\n    .kpv-raw {\n      text-align: center;\n    }\n  }\n\n  .kd[data-kd-mode=\"view\"] {\n    .kp[data-kp-empty=\"true\"] {\n      display: none;\n    }\n\n    .kp[data-kp-empty=\"true\"][data-kt=\"minor_break\"] {\n      display: block;\n    }\n\n    .kp.kpdc-placeholder-empty[data-kp-empty=\"true\"] .kpv-raw:before {\n      display: flex;\n      content: \"Not provided\"\n    }\n  }\n\n  /*\n    .kp[data-kt=\"markdown\"] {\n      width: 100%;\n      \n      .kpv {\n        width: 100%;\n      }\n  \n      .kpv-raw {\n        text-align: center;\n        width: 100%;\n      }\n    }\n  */\n\n  .kp[data-kp-visibility=\"hidden\"] {\n    display: none;\n  }\n\n  .kp-sections {\n    width: 100%;\n    .kp-section {\n      width: 100%;\n      margin-top: 12px;\n    }\n  }\n\n  .ks-add-section {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n\n    .ks-add {\n      display: none;\n      padding: 0px;\n      border: none;\n      background: none;\n      color: #2991ED;\n      font-family: 'Poppins';\n      font-weight: 400;\n    }\n  }\n\n  .kpdc-numbered {\n    counter-reset: section;\n    .kp-section {\n      counter-increment: section;\n      .ks-name::after {\n        content: \" #\" counter(section);\n      }\n    }\n  }\n\n  .kpdc-not-required[data-kp-required=\"true\"] > .kp-name span:first-child:after {\n    content: \"\";\n  }\n}\n\n[data-kermit-document][data-kermit-debug=\"true\"] {\n  .kd-source, .kp-source {\n    display: block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
